import React, { useState, useEffect } from 'react';
import { Tabs, Spin } from 'antd';
import useGetScriptSureToken from 'hooks/useGetScriptSureToken';
import useGetScriptSurePatientId from 'hooks/useGetScriptSurePatientId';
import { getScriptSureUrl } from 'constants/common';

type Props = {
    prospectId?: number;
    isGroupPractice?: boolean;
};

const PrescriptionsAndPharmacy = ({ prospectId }: Props) => {
    const [scriptToken, loadingScriptToken, fetchScriptToken] = useGetScriptSureToken();
    const [scriptSurePatientId, loadingScriptSurePatientId, fetchScriptSurePatientId] = useGetScriptSurePatientId(prospectId);
    const [prescriptionsIframeLink, setPrescriptionsIframeLink] = useState<string>('');
    const [pharmacyIframeLink, setPharmacyIframeLink] = useState<string>('');
    const scriptSureUrl = getScriptSureUrl();

    React.useEffect(() => {
        // URL: https://ssu.scriptsure.com/widgets/drug-history/:patientId?sessiontoken=:sessionToken&appId=:templateId&darkmode=off
        //URL: https://ssu.scriptsure.com/widgets/pharmacy/:patientId?sessiontoken=:sessionToken&appId=:templateId&darkmode=off
        if (scriptToken && scriptSurePatientId) {
            setPrescriptionsIframeLink(`${scriptSureUrl}/widgets/drug-history/${scriptSurePatientId}?sessiontoken=${scriptToken.sessionToken}&darkmode=off`);
            setPharmacyIframeLink(`${scriptSureUrl}/widgets/pharmacy/${scriptSurePatientId}?sessiontoken=${scriptToken.sessionToken}&darkmode=off`);
        }
    }, [scriptToken, scriptSurePatientId]);

    const displayLink = prescriptionsIframeLink;

    return <div>
         {
            displayLink ? (
                <iframe src={displayLink} width="100%" height="900px" frameBorder="0" title="Prescribe medication" />
            ) : (
                <Spin />
            )
        }
    </div>;
};

export default PrescriptionsAndPharmacy;